<template>
    <label>
        <Select v-model="currValue" ref="select" clearable :placeholder="placeholder" @on-change="selectChange" :style="styles">
            <Option v-for="item in list" :value="item" :key="item">{{item}}</Option>
        </Select>
    </label>
</template>

<script>
    export default {
        name: "color-sel",
        props: {
            value: {
                type: String,
                default: '黄'
            },
            placeholder: {
                type: String,
                default: '请选择颜色'
            },
            width: {
                type: String,
                default: '150px'
            }
        },
        data() {
            return {
                currValue: this.value,
                list: ['红','黄','蓝','绿','白','黑','其他'],
            }
        },
        mounted() {
            this.dataInit();
        },
        methods: {
            dataInit() {

            },
            selectChange(val) {
                val = val === undefined ? null : val;
                this.currValue = val;
                if (val !== this.value) {
                    this.$emit('input', val);
                    this.$emit('on-change', val);
                }
            }
        },
        watch: {
            value(val) {
                val = val === undefined ? null : val;
                if (val !== this.currValue) {
                    this.currValue = val;
                }
            }
        },
        computed: {
            styles(){
                return 'width:'+this.width
            }
        }
    }
</script>
